/**
 * WizardStepContract — Step 2: Nature du contrat, dates, essai, préavis.
 * Extracted from ContractWizard.jsx for maintainability.
 */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Briefcase, CalendarDays, ShieldCheck } from 'lucide-react';

export const WizardStepContract = ({ data, onChange, children }) => (
  <div className="space-y-5">
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <Briefcase className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Type de contrat
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <Label>Type *</Label>
          <Select value={data.contract_type} onValueChange={(val) => onChange({ ...data, contract_type: val, end_date: val === 'cdi' ? '' : data.end_date })}>
            <SelectTrigger data-testid="wizard-contract-type"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="cdi">CDI</SelectItem>
              <SelectItem value="cdd">CDD</SelectItem>
              <SelectItem value="occasionnel">Occasionnel</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Année *</Label>
          <Select value={data.year_type} onValueChange={(val) => onChange({ ...data, year_type: val, weeks_per_year: val === 'complete' ? 52 : data.weeks_per_year })}>
            <SelectTrigger data-testid="wizard-year-type"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="complete">Complète (52 sem.)</SelectItem>
              <SelectItem value="incomplete">Incomplète</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {data.year_type === 'incomplete' && (
          <div>
            <Label>Semaines / an</Label>
            <Input type="number" min="1" max="51" value={data.weeks_per_year} onChange={(e) => onChange({ ...data, weeks_per_year: e.target.value })} data-testid="wizard-weeks-per-year" />
          </div>
        )}
      </div>
    </div>
    <Separator />
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <CalendarDays className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Dates
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <Label>Début du contrat *</Label>
          <Input type="date" value={data.start_date} onChange={(e) => onChange({ ...data, start_date: e.target.value })} required data-testid="wizard-start-date" />
        </div>
        {data.contract_type !== 'cdi' && (
          <div>
            <Label>Fin du contrat</Label>
            <Input type="date" value={data.end_date} onChange={(e) => onChange({ ...data, end_date: e.target.value })} data-testid="wizard-end-date" />
          </div>
        )}
        <div>
          <Label>Date de signature</Label>
          <Input type="date" value={data.signature_date} onChange={(e) => onChange({ ...data, signature_date: e.target.value })} data-testid="wizard-signature-date" />
        </div>
      </div>
    </div>
    <Separator />
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <ShieldCheck className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Période d'essai & Préavis
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <Label>Période d'essai (semaines)</Label>
          <Input type="number" min="0" max="12" value={data.trial_period_weeks} onChange={(e) => onChange({ ...data, trial_period_weeks: e.target.value })} data-testid="wizard-trial-period" />
          <p className="text-xs mt-1 text-[var(--text-tertiary)]">0 = pas de période d'essai (facultative, doit être mentionnée)</p>
        </div>
        <div>
          <Label>Préavis (mois)</Label>
          <Input type="number" min="1" max="6" value={data.notice_period_months} onChange={(e) => onChange({ ...data, notice_period_months: e.target.value })} data-testid="wizard-notice-period" />
        </div>
      </div>
      <div>
        <Label>Modalités de la période d'adaptation</Label>
        <Textarea value={data.adaptation_details} onChange={(e) => onChange({ ...data, adaptation_details: e.target.value })} placeholder="Ex: 1 semaine d'adaptation progressive avec horaires réduits..." rows={2} data-testid="wizard-adaptation" />
      </div>
    </div>
    {children}
  </div>
);
